import { render, staticRenderFns } from "./NsTip.vue?vue&type=template&id=057f5df9&scoped=true&"
import script from "./NsTip.vue?vue&type=script&lang=js&"
export * from "./NsTip.vue?vue&type=script&lang=js&"
import style0 from "./NsTip.vue?vue&type=style&index=0&id=057f5df9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f5df9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsIcon: require('/usr/app/src/components/ns/NsIcon.vue').default})
